
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import Alert from 'element-ui/lib/alert';
import 'lodash/isEqual';
import 'just-kebab-case';
import { P as PendoAnalytics } from './labels-mixin.js';

var script = {
  name: 'PendoAlert',
  components: {
    ElAlert: Alert
  },
  directives: {
    PendoAnalytics
  },
  props: {
    type: {
      default: 'info',
      type: String,
      validator: value => ['error', 'info', 'success', 'warning'].includes(value)
    },
    title: {
      default: '',
      type: String
    },
    description: {
      default: '',
      type: String
    },
    center: {
      default: false,
      type: Boolean
    },
    showIcon: {
      default: true,
      type: Boolean
    },
    closable: {
      default: false,
      type: Boolean
    },
    inline: {
      default: false,
      type: Boolean
    }
  },
  methods: {
    handleClose(event) {
      this.$emit('close', event);
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('el-alert', {
    directives: [{
      name: "pendo-analytics",
      rawName: "v-pendo-analytics",
      value: {
        type: 'components:alert',
        value: _vm.type
      },
      expression: "{ type: 'components:alert', value: type }"
    }],
    staticClass: "pendo-alert",
    class: {
      'is-inline': _vm.inline
    },
    attrs: {
      "type": _vm.type,
      "title": _vm.title,
      "description": _vm.description,
      "closable": _vm.closable,
      "center": _vm.center,
      "show-icon": _vm.showIcon
    },
    on: {
      "close": _vm.handleClose
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-alert.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoAlert = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoAlert;
